import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Text } from '@bonusly/design-system';
import { useCurrentUser } from '@bonusly/who-am-i';

import { PendingMessage } from '../message';
import { useEvaluation } from './context';

export const PendingResponse: FC = () => {
	const evaluation = useEvaluation();
	const user = useCurrentUser();
	const { t } = useTranslation('feedback');

	if (!evaluation.isPending() || !evaluation.receiverIs(user.id) || evaluation.isExpired()) {
		return null;
	}

	return (
		<>
			<Box border="1px solid" borderColor="border.default" borderRadius="md" p={3} textAlign="center">
				<Text color="text.softer" size="md" variant="strong" mb={1}>
					{t('pending.title', { name: evaluation.firstGiver().name })}
				</Text>
				<Text color="text.softest">{t('pending.description')}</Text>
			</Box>

			<PendingMessage userId={evaluation.firstGiver().id} />
		</>
	);
};
